"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrRetrieveWallet = exports.clearWallet = void 0;
const ethers_1 = require("ethers");
const isPrivateKeyValid_1 = require("../../helpers/isPrivateKeyValid/isPrivateKeyValid");
const wallet_1 = require("../wallet");
const required_1 = require("../../helpers/required/required");
const key = 'spkz_proxyWalletPK';
const createOrRetrieveWallet = () => {
    required_1.requiredDefined(window, '1/ this method is intended to be used on a browser');
    required_1.requiredDefined(window.localStorage, '2/ this method is intended to be used on a browser');
    let pk = window.localStorage.getItem(key);
    if (!pk) {
        pk = ethers_1.Wallet.createRandom().privateKey;
        window.localStorage.setItem(key, pk);
    }
    if (isPrivateKeyValid_1.isPrivateKeyValid(pk)) {
        return wallet_1.SPKZ.fromPrivateKey(pk);
    }
    else {
        throw new Error('private key is not valid');
    }
};
exports.createOrRetrieveWallet = createOrRetrieveWallet;
const clearWallet = () => {
    window.localStorage.removeItem(key);
    return createOrRetrieveWallet();
};
exports.clearWallet = clearWallet;
//# sourceMappingURL=walletCreator.js.map